export const MOVE_STEP = 200;
export const ARROW_WIDTH = 20;
export const TAB_PADDING = 24; // $tabPaddingRight + $tabPaddingLeft
